// parley real-time media: the subset of livekit-client's API that the
// Fluxer client uses, implemented over MoQ (moq.dev) instead of WebRTC/SFU.
// See docs/voice.md and web/FORK.md (rule 5).
export {ExternalE2EEKeyProvider, isE2EESupported} from './e2ee';
export {
	BackupCodecPolicy,
	ConnectionQuality,
	ConnectionState,
	ParticipantEvent,
	RoomEvent,
	TrackEvent,
	type VideoCodec,
	type VideoEncoding,
	VideoPreset,
	VideoPresets,
	VideoQuality,
} from './enums';
export type {
	AudioCaptureOptions,
	AudioProcessorOptions,
	DataPublishOptions,
	ProcessorOptions,
	RoomConnectOptions,
	RoomOptions,
	ScreenShareCaptureOptions,
	TrackProcessor,
	TrackPublishDefaults,
	TrackPublishOptions,
	VideoCaptureOptions,
	VideoProcessorOptions,
} from './options';
export {
	createLocalAudioTrack,
	createLocalVideoTrack,
	LocalParticipant,
	Participant,
	RemoteParticipant,
} from './participant';
export {LocalTrackPublication, RemoteTrackPublication, TrackPublication} from './publication';
export {DisconnectReason, Room} from './room';
export {
	LocalAudioTrack,
	LocalTrack,
	LocalVideoTrack,
	RemoteAudioTrack,
	RemoteTrack,
	RemoteVideoTrack,
	Track,
} from './track';

/** MoQ sends one encoding per track: no simulcast layers, no SVC modes. */
export function supportsScalabilityMode(): boolean {
	return false;
}

/**
 * LiveKit's answer: what the browser's WebRTC sender lists. The codec policy
 * built on it only steers Fluxer's codec menus; @moq/publish picks the actual
 * WebCodecs encoder per catalog. Without WebRTC, whatever WebCodecs offers.
 */
export function supportsVideoCodec(codec: string): boolean {
	const sender = (globalThis as {RTCRtpSender?: {getCapabilities?: (kind: string) => RTCRtpCapabilities | null}})
		.RTCRtpSender;
	if (typeof sender?.getCapabilities === 'function') {
		const mimeType = `video/${codec}`.toLowerCase();
		return (sender.getCapabilities('video')?.codecs ?? []).some((c) => c.mimeType.toLowerCase() === mimeType);
	}
	return typeof VideoEncoder !== 'undefined' && ['vp8', 'vp9', 'h264', 'av1', 'h265'].includes(codec);
}
